import { isEmpty, isNil, isUndefined } from 'lodash';

export const normalizeSectionForCompare = ({
    id,
    content,
    included,
    attachments,
}: {
    id: string;
    content: any;
    included: boolean;
    attachments?: string[];
}) => {
    if (id !== 'budget_and_timeline') {
        return { id, content, included, attachments };
    }

    const normalizedContent = { ...content };

    if (normalizedContent?.pricingType === 'FIXED') {
        delete normalizedContent.hourlyBudgetRange;
    }

    if (normalizedContent?.pricingType === 'HOURLY') {
        delete normalizedContent.budgetInCents;
    }

    if (normalizedContent?.timelineDetails) {
        const cleanedTimelineDetails: Record<string, any> = {};

        for (const [key, value] of Object.entries(normalizedContent.timelineDetails)) {
            if (isNil(value)) continue;

            if (typeof value === 'object' && isEmpty(value)) {
                continue;
            }

            cleanedTimelineDetails[key] = value;
        }

        if (isEmpty(cleanedTimelineDetails)) {
            delete normalizedContent.timelineDetails;
        } else {
            normalizedContent.timelineDetails = cleanedTimelineDetails;
        }
    }

    if ('deliveryDate' in normalizedContent && isUndefined(normalizedContent.deliveryDate)) {
        delete normalizedContent.deliveryDate;
    }

    return {
        id,
        content: normalizedContent,
        included,
        attachments,
    };
};
